import {moveCustomerOfferToDraft} from "@project/sdk/sales";
import {MoveCustomerOfferToDraftResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {customerOfferKeys, customerOfferMutationKeys} from "../../../customerOffer-keys";

export function moveCustomerOfferToDraftMutationOptions() {
  return mutationOptions({
    mutationKey: customerOfferMutationKeys.moveCustomerOfferToDraft,
    mutationFn: async (id: string) =>
      MoveCustomerOfferToDraftResponse.parse(await moveCustomerOfferToDraft(id)),
    onSuccess: async (_result, ownerId, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: customerOfferKeys.detail(ownerId)}),
        client.invalidateQueries({queryKey: customerOfferKeys.lists()}),
      ]);
    },
  });
}
